import {EVENT_PREFIX} from '../../../helpers';

export default (input) => ({
  ...{
    type: `${EVENT_PREFIX}_VALIDATE_INIT`
  },
  ...input
});
